import { component } from './widgetApp.exports';
import { ComponentNoSentryWithAppSettingData } from './app.exports';

//file has to be js
export default {
  component,
  ComponentNoSentryWithAppSettingData,
};
